import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Input from "../../../../components/common/inputs/Input";
import Button from "../../../../components/common/button/Button";
import ImagesModal from "../../../../components/common/modals/imgaes-modal/ImagesModal";
import { publicImageProps } from "../../../../services/config";
import Editor from "../../../../components/common/ck-editor/CkEditor";
import { useLocation } from "react-router";

const { forwardRef, useRef, useImperativeHandle } = React;

const InstructorInfo = forwardRef(
  ({ instructorData, handleInstructor }, ref) => {
    const location = useLocation();
    const [description, setDescription] = useState("");
    const [showModal, setShowModal] = useState(false);

    useImperativeHandle(ref, () => ({
      showModal() {
        setShowModal(!showModal);
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      afterSubmit() {
        setInstructorInfo(null);
      },
    }));
    const [instructorInfo, setInstructorInfo] = useState(null);
    const [image, setImage] = useState(null);

    const formHandler = async (values, { resetForm }) => {
      handleInstructor({
        ...values,
        description,
        image: image || "",
      });
      setShowModal(false);
    };

    useEffect(() => {
      if (instructorData) {
        setInstructorInfo(instructorData);
        if (instructorData?.image) {
          setImage(instructorData?.image);
        }
      }
    }, [instructorData]);

    const imagesModal = useRef();

    const handleImages = (data) => {
      setImage(data.name);
    };

    return (
      <>
        <div
          className={`admin-edit-backdrop fixed top-0 right-0 w-full h-full transition-all z-30  ${!showModal && "hidden"
            }`}
        ></div>
        <div
          hidden={!showModal}
          role="dialog"
        aria-label="اطلاعات مدرس"
          aria-modal="true"
          className={`admin-edit-drawer w-full h-full overflow-y-scroll  bg-white shadow-md z-40 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${showModal && "!left-0 is-open"
            }`}
        >
          <Formik
            enableReinitialize
            initialValues={{
              title: instructorInfo?.title || "",
              videoUrl: instructorInfo?.videoUrl || "",
            }}
            onSubmit={formHandler}
          >
            {() => (
              <Form>
                <div className="flex w-full items-center justify-between">
                  <h4>اطلاعاتی درباره مدرس</h4>
                  <Button type="submit" color="primary" text="بازگشت" />
                </div>

                <div className="grid gap-6 my-4 md:grid-cols-2">
                  <Input
                    name={"title"}
                    placeholder="عنوان"
                    label="عنوان"
                    type="text"
                  /> 

                  <Input
                    name={"videoUrl"}
                    placeholder="آدرس ویدئو"
                    label="آدرس ویدئو"
                    type="text"
                  />
                  <Input
                    name={"voiceUrl"}
                    placeholder="آدرس صدا"
                    label="آدرس صدا"
                    type="text"
                  />
                
                
                  <div className="">
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      تصویر مدرس
                    </label>
                    <div className="flex items-center justify-between">
                      <div className="flex gap-2">
                        {image ? (
                          <img
                            {...publicImageProps(image, { variant: "thumb_" })}
                            className="w-16 h-16 rounded-lg"
                            alt=""
                          />
                        ) : (
                          <p className="text-sm">هنوز هیچ عکسی اننتخاب نشده</p>
                        )}
                        {/* <p className="max-w-12 overflow-hidden">{image || ""}</p> */}
                      </div>
                      <div className="flex gap-2">
                        {image && (
                          <Button
                            type="button"
                            onClick={() => setImage("")}
                            text={"حذف"}
                            color={"danger"}
                          />
                        )}

                        <Button
                          type="button"
                          onClick={() => imagesModal.current.showModal()}
                          text={image ? "ویرایش" : "انتخاب"}
                          color={"success"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col">
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  توضیحات
                  </label>
                  <div className="flex flex-col gap-y-2">
                    <Editor defultData={location?.state?.instructorInfo?.description} onChange={setDescription} />
                  </div>
                  </div>
              </Form>
            )}
          </Formik>
        </div>
        <ImagesModal selectedImages={handleImages} ref={imagesModal} />
      </>
    );
  }
);
export default InstructorInfo;
